"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.9997 11.1428C18.4731 11.1428 18.8569 11.5266 18.8569 12C18.8569 12.4734 18.4731 12.8571 17.9997 12.8571C10.8252 12.8571 13.6974 12.8571 5.99972 12.8571C5.52633 12.8571 5.14258 12.4734 5.14258 12C5.14258 11.5266 5.52633 11.1428 5.99972 11.1428C13.2005 11.1428 10.2576 11.1428 17.9997 11.1428Z", fill: "currentColor" }));
